export default "__VITE_ASSET__D0i2Kpxi__"